export const FontsStyle = {
    style: {
        CARBONA: 'Carbona',
        CARBONA_BOLD: 'Carbona-bold',
    },
};
